import React, { useRef, useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

function Sidebar12() {
  const [isOpen1, setIsOpen1] = useState(false);
  const [isOpen2, setIsOpen2] = useState(false);
  const contentRef1 = useRef(null);
  const contentRef2 = useRef(null);

  const navigate = useNavigate();
  const location = useLocation();

  const toggleDropdown1 = () => {
    setIsOpen1(!isOpen1);
  };

  const toggleDropdown2 = () => {
    setIsOpen2(!isOpen2);
  };

  useEffect(() => {
    if (contentRef1.current) {
      contentRef1.current.style.maxHeight = isOpen1
        ? `${contentRef1.current.scrollHeight}px`
        : "0px";
    }
  }, [isOpen1]);

  useEffect(() => {
    if (contentRef2.current) {
      contentRef2.current.style.maxHeight = isOpen2
        ? `${contentRef2.current.scrollHeight}px`
        : "0px";
    }
  }, [isOpen2]);

  const isAddSchoolActive = [
    "/class-xii-add-qualifying-jac",
    "/class-xii-add-improvement-jac",
    "/class-xii-add-ex-regular-jac",
    "/class-xii-add-regular-jac",
    "/class-xii-upload-document",
    "/class-xii-add-ex-regular-info-jac",
    "/class-xii-add-improvement-info",
    "/class-xii-add-qualifying-info",
    "/class-xii-regular-student-info",
  ].includes(location.pathname);

  const isReportsActive = [
    "/class-xii-consolidated-checklist",
    "/class-xii-challan-status",
    "/class-xii-generate-challan",
    "/class-xii-checklist-generated",
    "/class-xii-total-registration",
  ].includes(location.pathname);

  const downloadadmit = (stream) => {
    const schoolID = sessionStorage.getItem("schoolCode");
    const districtid = sessionStorage.getItem("district");
    if (!schoolID) {
      alert("School ID is missing.");
      return;
    }

    const domain = window.location.origin;
    console.log(domain);
    const filePath = `${domain}/Admit_cards/${districtid}/${schoolID}/${stream}.pdf`;
    console.log(filePath);
    const link = document.createElement("a");
    link.href = filePath;
    link.download = `${stream}-admit-card-${schoolID}.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const downloadtr = () => {
    const domain = window.location.origin;
    const classFolder = "class-xii";
    const districtId = sessionStorage.getItem("district");
    const schoolId = sessionStorage.getItem("schoolCode");

    if (!schoolId) {
      alert("School ID is missing.");
      return;
    }
    if (!districtId) {
      alert("District ID is missing.");
      return;
    }
    const filePath = `${domain}/${classFolder}/${districtId}/${schoolId}.pdf`;
    const link = document.createElement("a");
    link.href = filePath;
    link.download = `Tabulation-Register-${schoolId}.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <nav className="sidebar sidebar-offcanvas" id="sidebar">
      <ul className="nav">
        <li
          className={`nav-item ${
            location.pathname === "/class-xii-dashboard" ? "active" : ""
          }`}
        >
          <a
            href="#"
            className="nav-link back-g"
            onClick={() => navigate("/class-xii-dashboard")}
          >
            <i className="icon-grid menu-icon"></i>
            <span className="menu-title">Dashboard</span>
          </a>
        </li>
        <li
          className={`nav-item ${
            location.pathname === "/class-xii-school-profile" ? "active" : ""
          }`}
        >
          <a
            href="#"
            className="nav-link back-g"
            onClick={() => navigate("/class-xii-school-profile")}
          >
            <i className="fa fa-university menu-icon"></i>
            <span className="menu-title">Profile</span>
          </a>
        </li>
        {/* First Dropdown */}
        <li className={`nav-item ${isAddSchoolActive ? "active" : ""}`}>
          <a
            className="nav-link back-g"
            onClick={toggleDropdown1}
            style={{ cursor: "pointer" }}
            aria-expanded={isOpen1}
            aria-controls="auth1"
          >
            <i className="icon-head menu-icon"></i>
            <span className="menu-title">Add Student</span>
            <i className="menu-arrow"></i>
          </a>
          <div id="auth1" ref={contentRef1} className="custom-collapse">
            <ul className="nav flex-column sub-menu sub-green">
              <li className="nav-item">
                <a
                  className="nav-link back-g"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate("/class-xii-add-regular-jac");
                  }}
                >
                  Class XII Regular
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link back-g"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate("/class-xii-add-ex-regular-jac");
                  }}
                  rel="noopener noreferrer"
                >
                  Ex-Regular
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link back-g"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate("/class-xii-add-improvement-jac");
                  }}
                  rel="noopener noreferrer"
                >
                  Improvement
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link back-g"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate("/class-xii-add-qualifying-jac");
                  }}
                  rel="noopener noreferrer"
                >
                  Qualifying Exam
                </a>
              </li>
            </ul>
          </div>
        </li>
        <li className={`nav-item ${isReportsActive ? "active" : ""}`}>
          <a
            className="nav-link back-g"
            onClick={toggleDropdown2}
            style={{ cursor: "pointer" }}
            aria-expanded={isOpen2}
            aria-controls="auth2"
          >
            <i className="icon-head menu-icon"></i>
            <span className="menu-title">Reports</span>
            <i className="menu-arrow"></i>
          </a>
          <div id="auth2" ref={contentRef2} className="custom-collapse">
            <ul className="nav flex-column sub-menu sub-green">
              <li className="nav-item">
                <a
                  className="nav-link back-g"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate("/class-xii-total-registration");
                  }}
                >
                  Total Registration
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link back-g"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate("/class-xii-checklist-generated");
                  }}
                  rel="noopener noreferrer"
                >
                  Checklist Generated
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link back-g"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate("/class-xii-generate-challan");
                  }}
                  rel="noopener noreferrer"
                >
                  Generate Challan
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link back-g"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate("/class-xii-challan-status");
                  }}
                  rel="noopener noreferrer"
                >
                  Challan Status
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link back-g"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate("/class-xii-consolidated-checklist");
                  }}
                  rel="noopener noreferrer"
                >
                  List of Examinees
                </a>
              </li>
            </ul>
          </div>
        </li>
        {sessionStorage.getItem("correctionstatus12") === "ON" && (
          <li className="nav-item">
            <a
              className="nav-link back-g"
              href="#"
              onClick={(e) => {
                e.preventDefault();
                navigate("/class-xii-correct-student");
              }}
            >
              <i class="fa fa-check menu-icon"></i>
              <span className="menu-title ">Correct Student Data</span>
            </a>
          </li>
        )}
        {/* {sessionStorage.getItem("class12profile") === "YES" && ( */}
        <li
          className={`nav-item ${
            location.pathname === "/class-xii-data-not-found" ? "active" : ""
          }`}
        >
          <a
            className="nav-link text-danger back-g"
            href="#"
            onClick={(e) => {
              e.preventDefault();
              navigate("/class-xii-data-not-found");
            }}
          >
            <i class="fa fa-times menu-icon text-danger"></i>
            <span className="menu-title ">Data Not Found</span>
          </a>
        </li>
        {/* )} */}
        {/* {sessionStorage.getItem("class12profile") === "YES" && ( */}
        <li
          className={`nav-item ${
            location.pathname === "/class-xii-data-not-found-list"
              ? "active"
              : ""
          }`}
        >
          <a
            className="nav-link text-danger back-g"
            href="#"
            onClick={(e) => {
              e.preventDefault();
              navigate("/class-xii-data-not-found-list");
            }}
          >
            <i class="fa fa-list menu-icon text-danger"></i>
            <span className="menu-title " style={{ fontSize: "13px" }}>
              Status of Data Not Found
            </span>
          </a>
        </li>
        {/* )} */}
        {sessionStorage.getItem("class12admitcardbutton") === "ON" &&
          sessionStorage.getItem("class12artsadmit") === "ON" && (
            <li className="nav-item">
              <a
                className="nav-link back-g"
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  downloadadmit("Arts");
                }}
              >
                <i className="fa fa-download menu-icon"></i>
                <span className="menu-title">Admit Card (Arts)</span>
              </a>
            </li>
          )}
        {sessionStorage.getItem("class12admitcardbutton") === "ON" &&
          sessionStorage.getItem("class12commerceadmit") === "ON" && (
            <li className="nav-item">
              <a
                className="nav-link back-g"
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  downloadadmit("Comm");
                }}
              >
                <i className="fa fa-download menu-icon"></i>
                <span className="menu-title">Admit Card (Commerce)</span>
              </a>
            </li>
          )}
        {sessionStorage.getItem("class12admitcardbutton") === "ON" &&
          sessionStorage.getItem("class12scienceadmit") === "ON" && (
            <li className="nav-item">
              <a
                className="nav-link back-g"
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  downloadadmit("Science");
                }}
              >
                <i className="fa fa-download menu-icon"></i>
                <span className="menu-title">Admit Card (Science)</span>
              </a>
            </li>
          )}
        {sessionStorage.getItem("tabulationReg") === "ON" && (
          <li className="nav-item blink-text" style={{ padding: "1px 6px" }}>
            <a
              className="nav-link color btn btn-danger text-white"
              href="#"
              onClick={(e) => {
                e.preventDefault();
                downloadtr();
              }}
              style={{
                backgroundColor: "#dc3545",
                padding: "8px 12px",
                borderRadius: "3px",
              }}
            >
              <i className="fa fa-download menu-icon text-white"></i>
              <span className="menu-title" style={{ fontSize: "12px" }}>
                TABULATION REGISTER
              </span>
            </a>
          </li>
        )}
      </ul>
    </nav>
  );
}

export default Sidebar12;
